/// <reference path="../../include.ts" />
namespace gpx_visualizer_phase2 {

	import View = alm.view.View;
	import DeviceInfo = alm.browser.DeviceInfo;

	export class SeekBar extends View<JQuery> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(view:JQuery) {
			super(view);

			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():JQuery {
			const view:JQuery = this.getView();

			this.handle = view.find('.handle');
			this.progress = view.find('.progress');
			this.base = view.find('.base');
			this.baseHitArea = view.find('.base-hitarea');
			this.body = jQuery('body');

			const handleElm = this.handle.get(0);
			const baseHitAreaElm = this.baseHitArea.get(0);
			if (DeviceInfo.getIsTouchEnabled()) {
				handleElm.addEventListener('touchstart', this.handleTouchStartHandler);
				baseHitAreaElm.addEventListener('touchstart', this.baseTouchStartHandler);
			} else {
				handleElm.addEventListener('mouseover', this.handleMouseOverHandler);
				handleElm.addEventListener('mouseout', this.handleMouseOutHandler);
				handleElm.addEventListener('mousedown', this.handleMouseDownHandler);
				baseHitAreaElm.addEventListener('mouseover', this.baseMouseOverHandler);
				baseHitAreaElm.addEventListener('mouseout', this.baseMouseOutHandler);
				baseHitAreaElm.addEventListener('mousedown', this.baseMouseDownHandler);
			}

			this.soundInterval = 50;
			this.soundTime = 0;

			return view;
		}

		protected implReady():void {
		}

		protected implFinalize():void {
		}

		protected implShow(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.css('display', 'block');
			});
		}

		protected implHide(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.css('display', 'none');
			});
		}

		public setState(ratio:number):void {
			if (ratio < 0) ratio = 0;
			if (ratio > 1) ratio = 1;
			this.ratio = ratio;

			const prop = (ratio * 100) + '%';
			this.handle.css('left', prop);
			this.progress.css('width', prop);
		}

		public getIsDragging():boolean {
			return this.isMouseDown;
		}





		private startHandleDrag(clientX:number, clientY:number):void {
			if (this.isMouseDown) return;
			this.isMouseDown = true;

			this.mouseDownX = clientX; // global coordinate
			this.mouseDownY = clientY;

			this.mouseDragX = 0;
			this.mouseDragY = 0;

			const objectPosition = this.handle.position(); // local coordinate
			this.mouseDownObjectX = objectPosition.left;
			this.mouseDownObjectY = objectPosition.top;

			if (DeviceInfo.getIsTouchEnabled()) {
				window.addEventListener('touchmove', this.windowTouchMoveHandler);
				window.addEventListener('touchend', this.windowTouchEndHandler);
			} else {
				window.addEventListener('mousemove', this.windowMouseMoveHandler);
				window.addEventListener('mouseup', this.windowMouseUpHandler);
			}

			AudioPlayer.getInstance().getClip(AudioId.slider).play();

			this.dispatchEvent(new ControllerSeekBarEvent(ControllerSeekBarEvent.DRAG_START, this, this.ratio));
		}

		private endDrag():void {
			if (!this.isMouseDown) return;
			this.isMouseDown = false;

			this.body.css('cursor', 'auto');

			if (DeviceInfo.getIsTouchEnabled()) {
				window.removeEventListener('touchmove', this.windowTouchMoveHandler);
				window.removeEventListener('touchend', this.windowTouchEndHandler);
			} else {
				window.removeEventListener('mousemove', this.windowMouseMoveHandler);
				window.removeEventListener('mouseup', this.windowMouseUpHandler);
			}

			this.dispatchEvent(new ControllerSeekBarEvent(ControllerSeekBarEvent.DRAG_END, this, this.ratio));
		}

		private startBaseDrag(clientX:number, clientY:number, offsetX:number, offsetY:number):void {
			// seek
			let ratio = offsetX / this.base.width();
			ratio = ratio < 0 ? 0 : ratio > 1 ? 1 : ratio;
			if (ratio != this.ratio) {
				this.dispatchEvent(new ControllerSeekBarEvent(ControllerSeekBarEvent.SEEK, this, ratio));
			}

			// drag start
			this.startHandleDrag(clientX, clientY);

			// sound
			this.soundTime = Date.now();
			AudioPlayer.getInstance().getClip(AudioId.slider).play();
		}

		private moveDrag(clientX:number, clientY:number):void {
			this.mouseDragX = clientX - this.mouseDownX;
			this.mouseDragY = clientY - this.mouseDownY;

			let ratio = (this.mouseDownObjectX + this.mouseDragX) / this.base.width();
			ratio = ratio < 0 ? 0 : ratio > 1 ? 1 : ratio;
			if (ratio != this.ratio) {
				this.dispatchEvent(new ControllerSeekBarEvent(ControllerSeekBarEvent.SEEK, this, ratio));
			}

			// sound
			//const time = Date.now();
			//if (time - this.soundTime >= this.soundInterval) {
			//	this.soundTime = time;
			//	AudioPlayer.getInstance().getClip(AudioId.slider).play();
			//}
		}





		private handleMouseOverHandler = (event:MouseEvent):void => {
			event.preventDefault();
			event.stopPropagation();
			this.body.css('cursor', 'pointer');
		};

		private handleMouseOutHandler = (event:MouseEvent):void => {
			event.preventDefault();
			event.stopPropagation();
			if (!this.isMouseDown) {
				this.body.css('cursor', 'auto');
			}
		};

		private handleMouseDownHandler = (event:MouseEvent):void => {
			if (this.isMouseDown) return;
			trace('[SeekBar] handle mouse down');
			event.preventDefault();
			event.stopPropagation();
			this.startHandleDrag(event.clientX, event.clientY);
		};

		private baseMouseOverHandler = (event:MouseEvent):void => {
			event.preventDefault();
			event.stopPropagation();
			this.body.css('cursor', 'pointer');
		};

		private baseMouseOutHandler = (event:MouseEvent):void => {
			event.preventDefault();
			event.stopPropagation();
			if (!this.isMouseDown) {
				this.body.css('cursor', 'auto');
			}
		};

		private baseMouseDownHandler = (event:MouseEvent):void => {
			if (this.isMouseDown) return;
			trace('[SeekBar] base mouse down');
			event.preventDefault();
			event.stopPropagation();
			this.startBaseDrag(event.clientX, event.clientY, event.offsetX, event.offsetY);
		};

		private windowMouseMoveHandler = (event:MouseEvent):void => {
			//trace('[SeekBar] window mouse move');
			event.preventDefault();
			event.stopPropagation();
			this.moveDrag(event.clientX, event.clientY);
		};

		private windowMouseUpHandler = (event:MouseEvent):void => {
			trace('[SeekBar] window mouse up');
			event.preventDefault();
			event.stopPropagation();
			this.endDrag();
		};





		private handleTouchStartHandler = (event:TouchEvent):void => {
			if (this.isMouseDown) return;
			trace('[SeekBar] handle touch start');
			event.preventDefault();
			event.stopPropagation();
			const touch = event.touches[0];
			this.startHandleDrag(touch.clientX, touch.clientY);
		};

		private baseTouchStartHandler = (event:TouchEvent):void => {
			if (this.isMouseDown) return;
			trace('[SeekBar] base touch start');
			event.preventDefault();
			event.stopPropagation();
			const touch = event.touches[0];
			const bounds = (<HTMLElement>event.target).getBoundingClientRect();
			const offsetX = (touch.clientX - window.pageXOffset - bounds.left);
			const offsetY = (touch.clientY - window.pageYOffset - bounds.top);
			this.startBaseDrag(touch.clientX, touch.clientY, offsetX, offsetY);
		};

		private windowTouchMoveHandler = (event:TouchEvent):void => {
			trace('[SeekBar] window touch move');
			event.preventDefault();
			event.stopPropagation();
			const touch = event.touches[0];
			this.moveDrag(touch.clientX, touch.clientY);
		};

		private windowTouchEndHandler = (event:TouchEvent):void => {
			trace('[SeekBar] window touch end');
			event.preventDefault();
			event.stopPropagation();
			this.endDrag();
		};




		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private handle:JQuery;
		private progress:JQuery;
		private base:JQuery;
		private baseHitArea:JQuery;
		private body:JQuery;

		private ratio:number;

		private isMouseDown:boolean;
		private mouseDownX:number;
		private mouseDownY:number;
		private mouseDragX:number;
		private mouseDragY:number;
		private mouseDownObjectX:number;
		private mouseDownObjectY:number;

		private soundInterval:number;
		private soundTime:number;
	}
}
